import "../styles/app/app.scss";
import Auth from "./auth/Auth";
import React from "react";
import routes from "./routes";
import { RouterProvider } from "react-router-dom";
import { PocrProvider } from "./context/pocrProvider";
import { FeatureFlagsProvider } from "./context/featureFlagsProvider";
import jwtAuthService from "./services/jwtAuthService";

const App = () => {
  const [currentUser, setCurrentUser] = React.useState(jwtAuthService.getUser()?.user);

  React.useEffect(() => {
    return jwtAuthService.onAuthStateChanged(setCurrentUser);
  }, []);

  return (<Auth>
    <PocrProvider>
      <FeatureFlagsProvider currentUser={currentUser}>
        <RouterProvider router={routes} >
        </RouterProvider>
      </FeatureFlagsProvider>
    </PocrProvider>
  </Auth>)
}

export default App;
